import React from 'react'
import PropTypes from 'prop-types'
import { VERTICAL_TRIPS } from 'AccountsConstants/app'

const switchItem = (vertical, url, name, label, isPWA) => {
  let returnTemp = null
  if (vertical) {
    switch (vertical) {
      case 'air':
        returnTemp = (
          <div
            className={`${
              isPWA ? 'flex-middle' : 'flex-column pb-1 flex-top'
            } flex pwa-flight-title`}
          >
            <img src={url} alt="flight thumbnail" />
            <p className={`color-8a ${isPWA ? 'fs-13 pl-8' : 'fs-caption-2 pt-2 pb-2'}`}>
              {isPWA ? `${name} ${label}` : name}
            </p>
            <If condition={!isPWA && label}>
              <p className="color-8a fs-caption-2">{label}</p>
            </If>
          </div>
        )
        break
      case 'hotel':
        returnTemp = <img src={url} alt="hotel thumbnail" />
        break
      default:
        returnTemp = null
    }
  }
  return returnTemp
}
const Thumbnail = ({ url, name = '-', vertical, isPWA, label }) => (
  <React.Fragment>{switchItem(vertical, url, name, label, isPWA)}</React.Fragment>
)
Thumbnail.defaultProps = {
  name: '-',
  url: null,
  label: ''
}
Thumbnail.propTypes = {
  url: PropTypes.string,
  label: PropTypes.string,
  isPWA: PropTypes.bool.isRequired,
  name: PropTypes.string,
  vertical: PropTypes.oneOf(VERTICAL_TRIPS).isRequired
}
export default Thumbnail
